import React, { useState, useEffect, useRef } from 'react';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import './VideoAuto.scss';

gsap.registerPlugin(ScrollTrigger);

export default function VideoAuto({ fields }) {
  const contentTargetRefComp = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const container = contentTargetRefComp.current;
    if (!container) return;

    ScrollTrigger.create({
      trigger: container,
      start: 'top center',
      end: () => '0', // 每个区块固定一个视口高度
      pin: true,
      pinSpacing: true,
      // 可选：添加进入/离开时的回调
      onUpdate: () => {
        const video = videoRef.current;
        if (!video) {
          return;
        }

        video.muted = true;
        video.playsInline = true;
        video.play().catch(() => {
          // 浏览器可能仍然阻止自动播放，保持静默失败不会报错
        });
      },
    });

    return () => {
      // 清理所有 ScrollTrigger
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div ref={contentTargetRefComp} className="VideoAuto">
      <div className="VideoAuto_content">
        <video ref={videoRef} src={fields.videoUrl?.value?.href || ''} muted playsInline />
      </div>
    </div>
  );
}
